import React from "react"
import parse from "html-react-parser"
import { autop } from '@wordpress/autop';
import styled from "styled-components"
import "@wordpress/block-library/build-style/common.css"
import "@wordpress/block-library/build-style/style.css"
import "@wordpress/block-library/build-style/theme.css"

//import Bio from "../components/bio"
import Layout from "../components/layout"
import Seo from "../components/seo"
import useSiteMetadata from "../hooks/use-site-metadata"
import AppointmentForm from "../components/sections/form"

const Article = styled.article`
	margin-bottom: 2rem;
	font-size: clamp(1.125rem, 0.9044rem + 0.5882vw, 1.375rem);

	p, li {
		font-size: clamp(1.125rem, 0.9044rem + 0.5882vw, 1.375rem);
		line-height: 1.5;
	}
`

const PageHeader = styled.div`
margin-top: -66px;
padding-top: 66px;
background-color: #fff;
background-image: url("../images/reset/reset-single-hero-bg.png");
background-repeat: no-repeat;
background-size: cover;
background-position: top center;
`

const PageTitle = styled.h1`
display: flex;
flex-direction: column;
align-items: center;
padding: 90px 1rem 0;
margin: 0 auto;
max-width: 1060px;
text-align: center;
font-size: clamp(2rem, -0.6471rem + 7.0588vw, 5rem);
`

const ContentWrap = styled.div`
	max-width: 100vw;
	position: relative;
	overflow-x: clip;

	&, > section {
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	> section > * {
		width: 100%;
		max-width: 1080px;
		margin-left: 1.0875rem;
		margin-right: 1.0875rem;

		&.alignwide {
			max-width: 1200px;
		}

		&.alignfull {
			max-width: 100%;
			margin-left: 0;
			margin-right: 0;
		}
	}

	.wp-block-cover-image .wp-block-cover__image-background, .wp-block-cover-image video.wp-block-cover__video-background, .wp-block-cover .wp-block-cover__image-background, .wp-block-cover video.wp-block-cover__video-background {
		position: absolute !important;
	}

	.wp-block-cover {
		margin-bottom: 2rem;
	}

	@media only screen and (max-width: 745px) {
		flex: 2;
		min-width: 100%;
		margin-right: 0;
	}
`

const StickyColumn = styled.div`
	--content-width: calc(1080px + 1.0875rem * 2);
	--sidebar-width: max(calc(calc(100vw - var(--content-width)) / 2), 350px);
	--offset: calc(calc(100vw - 2rem) * -1);

    position: absolute;
    top: 0;
	right: var(--offset);
    width: calc(100vw - 2rem);
    height: 100%;
	z-index: 4;
	background-color: rgba(0, 0, 0, 0);
	transition: right 0.5s ease-in-out, background-color 0.5s ease-in-out;

	&.active {
		right: 0;
		padding-right: 2rem;
		padding-left: 2rem;
		width: 100vw;
		background-color: rgba(0, 0, 0, 0.5);


		.toggle-form {
			right: 0;

			&:after {
				content: '»';
			}
		}
	}

	.toggle-form {
		position: absolute;
		top: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 2rem;
		height: 2rem;
		right: calc(calc(var(--offset)) * -1);
		z-index: 999;
		background-color: rgb(34, 42, 63);
		color: white;
		border: none;
		padding: 1rem;
		cursor: pointer;
		transition: right 0.5s ease-in-out;
		
		&:after {
			content: '«';
			display: block;
		}

		span {
			clip: rect(0 0 0 0);
			clip-path: inset(50%);
			height: 1px;
			overflow: hidden;
			position: absolute;
			width: 1px;
		}
	}

	> div.sticky-box {
		position: sticky;
		top: 100px;
	}

	form[class] {
		width: 100%;
		max-width: 100%;
	}

	@media (prefers-reduced-motion: reduce) {
		&, * {
			transition: none !important;
		}
	}
`;

const CTAformPage = ({ data: { post } }) => {
	const slug = post.uri.replace("/", "")

	const vimeoMatch = /<div class="[^"]*container-vimeo[^>]+>[^>]+>(https?:\/\/player.vimeo.com\/video\/[^<]+).+?<\/div>/g
	const vimeoReplace =
		'<iframe src="$1" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>'

	const ytMatch = /<div class="[^"]*container-youtube[^>]+>[^>]+>https?:\/\/www.youtube.com\/watch\?v=([^&<]+).+?<\/div>/g
	const ytReplace =
		'<iframe width="560" height="315" src="https://www.youtube.com/embed/$1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'

	const ctaMatch = /Start Your <strong>Transformation!<\/strong>/g
	const ctaReplace = 'Request Appointment'

	const seo = post.seo || {};

	React.useEffect(() => {
		if ( 'online-booking-disclaimer' === slug ) {
			return;
		}

		// Find first element that is 100vh down the page in .entry-content.
		const content = document.querySelector('.entry-content');
		const elements = content.children;
		const windowHeight = window.innerHeight;
		const scrollOffset = 100;
		let lastElement = null;

		for (let i = 0; i < elements.length; i++) {
			const element = elements[i];
			const rect = element.getBoundingClientRect();

			if (rect.top > windowHeight - scrollOffset) {
				lastElement = element;
				break;
			}
		}

		if (lastElement) {
			// Insert new container the same height as .sticky-box plus 4rem padding.
			const container = document.createElement('div');
			const stickyBox = document.querySelector('.sticky-box');
			const stickyBoxHeight = stickyBox.clientHeight;
			const toggleButton = stickyBox.querySelector('.toggle-form');
			const padding = 4 * 16;
			let intersectToggled = false;

			container.style.height = `${stickyBoxHeight + padding}px`;
			container.style.width = '100%';
			container.style.margin = '0';
			container.style.padding = '0';
			container.style.border = '0';

			// Insert container after lastElement.
			content.insertBefore(container, lastElement.nextSibling);

			// Add scroll event listener.
			const handleScroll = () => {
				const rect = container.getBoundingClientRect();
				const top = rect.top;
				const bottom = rect.bottom;
				const windowHeight = window.innerHeight;
				
				if (top > 0 && bottom < windowHeight) {
					stickyBox.parentElement.classList.add('active');
					stickyBox.style.top = `${top + (padding/2)}px`;
					toggleButton.style.display = 'none';
					intersectToggled = true;
				} else if (intersectToggled) {
					intersectToggled = false;
					stickyBox.parentElement.classList.remove('active');
					stickyBox.style.transition = 'top 0.5s ease-in-out';
					toggleButton.style.display = 'flex';
					setTimeout(() => {
						stickyBox.style.top = '100px';
					}, 500);
					setTimeout(() => {
						stickyBox.style.transition = 'none';
					},1000);
				}
			}

			window.addEventListener('scroll', handleScroll);

			// Cleanup.
			return () => {
				window.removeEventListener('scroll', handleScroll);
				container.remove();
			}
		}
	},[]);

	return (
		<Layout slug={slug}>
			<Seo title={seo.title || post.title} description={seo.metaDesc  || ''} seo={seo} />
			<style
				dangerouslySetInnerHTML={
					{
						__html: `
						.page-header:not(.sticky){
							box-shadow: none;
						}
						.page-header:not(.sticky),
						.page-header:not(.sticky) #header-menu-toggle {
							background-color: transparent;
						}

						@media (min-width: 1204px) {
							.page-header:not(.sticky) *:not(#header-menu-explore, #header-menu-explore-toggle, #search-toggle) {
								background-color: transparent;
							}
						}
						`
					}
				}
			/>
			<Article
				className="blog-post"
				itemScope
				itemType="http://schema.org/Article"
			>
				<header>
					<PageHeader>
						{post.title && <PageTitle itemProp="headline">{parse(post.title)}</PageTitle>}
					</PageHeader>
				</header>

				<ContentWrap>
					{!!post.content && (
						<section itemProp="articleBody" className="entry-content">
							{parse(
								autop(
									post.content
										.replaceAll(vimeoMatch, vimeoReplace)
										.replaceAll(ytMatch, ytReplace)
										.replaceAll(ctaMatch, ctaReplace)
										.replaceAll('src="/wp-content', 'src="https://source.adamscheinermd.com/wp-content')
								)
							)}
						</section>
					)}

					<hr />

					{'online-booking-disclaimer' !== slug && <StickyColumn>
						<div className="sticky-box">
							<button className="toggle-form" onClick={(e) => {
								e.preventDefault();
								e.stopPropagation();
								const button = e.target;
								const column = button.parentElement.parentElement;

								column.classList.toggle('active');
							}}><span>Toggle Form</span></button>
							<AppointmentForm
								data = {{
									webHook: 'https://hooks.zapier.com/hooks/catch/4189994/23fiew5/',
									howDidYouHeaderAboutUsOptions: [],
									appointmentRegardingOptions: [],
									minFields: true,
									buttonText: 'Request Consultation',
								}}
							/>
						</div>
					</StickyColumn>}
				</ContentWrap>
			</Article>
		</Layout>
	)
}

export default CTAformPage
